/**
 * 알림 페이지 (/m/alim)
 *
 * 아래로 스크롤하면 과거 알림을 이어붙이고(MODE_OLDER), 2초마다 폴링해서 새 알림을 받는다(MODE_NEWER).
 * 폴링때는 화면에 보이는 오더의 updated_at 을 함께 보내, 그사이 바뀐 오더의 카드만 다시 그린다.
 */
import Util from '../../Common/Util';

// 조회 모드 — 서버 정렬이 서로 반대다.
const MODE_OLDER = 'p'; // 더보기: 과거 알림. 서버가 최신순(desc)
const MODE_NEWER = 'n'; // 폴링:   새 알림.  서버가 오래된순(asc)

const PAGE_SIZE     = 30;   // 더보기 한번에 가져올 개수
const POLL_SIZE     = 10;   // 폴링때 가져올 개수
const POLL_INTERVAL = 2000; // 폴링 주기(ms)

// 휴면·대기가 풀려 안내 화면(member/wait.blade.php)이 보낸 첫 도착 — 환영 토스트 1회. 읽는 즉시 지운다
const WELCOME_KEY = 'm:member:welcome';

// 같은 알림인지 — 서버의 g5_push_msg 유니크키와 같은 기준
const isSameNoti = (a, b) =>
    a.rel_table == b.rel_table && a.rel_id == b.rel_id && a.rel_action == b.rel_action && a.target == b.target;

export default class Alim {
    constructor() {
        this.notis     = [];  // 받아둔 알림행
        this.minPushnum = 0;  // 가진 알림번호의 최소 — 더보기 기준점
        this.maxPushnum = 0;  // 가진 알림번호의 최대 — 폴링 기준점
        this.lastDate   = ''; // 마지막으로 그린 날짜구분선

        this.isEnd      = false; // 더 가져올 알림이 없다
        this.isLoading  = false; // 요청중
        this.isPolling  = false; // 폴링 타이머가 떠 있다

        this.orderUptimes  = {};        // 그려둔 오더의 updated_at {ordernum: updated_at}
        this.visibleOrders = new Set(); // 지금 화면에 보이는 오더번호 — 폴링때 이것만 조회한다
        this.cardObserver  = null;      // 오더 카드 가시성 옵저버
    }

    initialize() {
        const observerOptions = { root: null, rootMargin: '300px', threshold: 0 };

        // 목록 끝 감시 — 바닥에 닿기 300px 전에 다음 페이지를 당겨온다.
        new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !this.isLoading && !this.isEnd) this.loadMore();
            });
        }, observerOptions).observe(document.getElementById('observer-target'));

        // 오더 카드 가시성 추적 — 스크롤을 아무리 내려도 폴링 조회대상이 뷰포트 크기로 고정된다.
        // 안 보이는 동안 바뀐 오더는 다시 보일때 orderUptimes 의 옛 값이 서버와 어긋나 자동 갱신된다.
        this.cardObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const ordernum = entry.target.dataset.ordernum;
                if (!ordernum) return;

                if (entry.isIntersecting) this.visibleOrders.add(ordernum);
                else this.visibleOrders.delete(ordernum);
            });
        }, observerOptions);

        $('#showMoreBtn').on('click', () => this.loadMore());   // 더보기 (자동 당겨오기가 못 미칠 때)

        this.welcomeBack();
        this.loadMore();
        // 환경설정→앱 동기화는 로그인 직후 묶음으로 이동 (Sites/Mobile/Bootstrap — 어느 화면 진입이든 커버)
    }

    /** 안내 화면에서 풀려 돌아온 회원에게 한 번만 인사한다 — 플래그는 안내 화면이 심고 여기서 지운다 */
    welcomeBack() {
        const Store = $j.Common.Store;
        if (Store.session.get(WELCOME_KEY) !== '1') return;
        Store.session.remove(WELCOME_KEY);
        $j.Ui.Toast.show('다시 오신 것을 환영합니다', { timeout: 2500 });   // 휴면 문구는 습니다체 (CS 요청)
    }

    /**
     * 과거 알림을 이어붙인다. (스크롤 바닥 / 더보기 버튼 — alim.blade.php 에서도 호출한다)
     */
    loadMore = () => {
        if (this.isEnd) return;
        this.request(this.minPushnum, PAGE_SIZE, MODE_OLDER);
    }

    /**
     * 새 알림과 오더 변경분을 가져온다. (폴링)
     */
    pollNew = () => {
        this.request(this.maxPushnum, POLL_SIZE, MODE_NEWER);
    }

    /**
     * 서버에 알림을 요청한다.
     * @param offset 기준 알림번호
     * @param limit  가져올 개수
     * @param mode   MODE_OLDER(더보기) / MODE_NEWER(폴링)
     */
    request = (offset, limit, mode) => {
        if (this.isLoading) return;
        this.isLoading = true;

        const param = { limit: limit, offset: offset, mode: mode };

        // 폴링일때는 지금 보이는 오더들의 updated_at 을 함께 보낸다.
        // 서버가 그사이 바뀐 오더의 알림행만 updates 로 돌려준다.
        if (mode == MODE_NEWER) param.orders = JSON.stringify(this.getVisibleOrders());

        $.ajax({
            type: 'POST',
            url: '/m/ajax/alim/list',
            data: param,
            success: (data) => {
                // count===0 이어도 mergeRows 는 반드시 태운다 — MODE_OLDER 는 여기서 isEnd 를 판정한다.
                // (예전엔 count>0 일때만 태워서, 알림이 아예 없으면 isEnd 가 절대 안 켜져 더보기가 계속 눌리는 상태로 남았다)
                this.render(this.mergeRows(data, mode), mode);
                if (data.updates && data.updates.length) this.applyUpdates(data.updates);

                // 첫 페이지부터 알림이 하나도 없는 경우 — 빈 상태 문구로 바꾸고 더보기를 아예 감춘다.
                if (mode == MODE_OLDER && this.isEnd && this.notis.length === 0) this.showEmptyState();

                this.isLoading = false;
            },
            complete: () => {
                this.startPolling();
            }
        });
    }

    /**
     * 첫 응답을 받은 뒤 폴링 타이머를 한번만 띄운다.
     * 앱이 백그라운드로 내려가 있는 동안은 요청하지 않고, 돌아오면 즉시 한번 따라잡는다.
     */
    startPolling = () => {
        if (this.isPolling) return;
        this.isPolling = true;

        setInterval(() => {
            if (document.hidden) return;
            this.pollNew();
        }, POLL_INTERVAL);

        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) this.pollNew();
        });
    }

    /**
     * 받아온 알림을 내부 목록에 합치고, 화면에 반영할 것들을 추려서 돌려준다.
     *
     * 같은 알림은 최신 1건만 남긴다. 서버 정렬이 mode 별로 반대라 어느쪽이 최신인지도 달라진다.
     *   MODE_NEWER(asc)  : 지금 들어온 row 가 더 최신 → 기존 행을 지운다
     *   MODE_OLDER(desc) : 이미 가진 행이 더 최신 → 지금 들어온 row 를 버린다
     *
     * @returns {{appends: array, removes: array}} appends 는 알림행 또는 날짜구분선(문자열)
     */
    mergeRows = (data, mode) => {
        if (mode == MODE_OLDER && data.count < PAGE_SIZE) {
            this.isEnd = true;
            $('#showMoreBtn').val('목록의 끝입니다');
        }

        const plan = { appends: [], removes: [] };

        data.list.forEach((row) => {
            const pushnum = parseInt(row.pushnum);
            if (pushnum > this.maxPushnum) this.maxPushnum = pushnum;
            if (this.minPushnum == 0 || pushnum < this.minPushnum) this.minPushnum = pushnum;

            const dups = this.notis.filter((v) => !v.removed && isSameNoti(v, row));
            if (mode == MODE_OLDER && dups.length) return; // 이미 더 최신 알림이 있다

            // 지워질 행은 removed 로 표시해둔다. 같은 배치에서 방금 appends 에 넣은 행일 수도 있어
            // (같은 객체 참조) 즉시 빼내지 않고, render 가 이 표시를 보고 건너뛴다.
            dups.forEach((v) => {
                v.removed = true;
                plan.removes.push(v.pushnum);
            });

            // 날짜가 바뀌었으면 날짜구분선을 끼워넣는다.
            if (mode == MODE_OLDER) {
                if (this.lastDate == '') this.lastDate = row.date;
                else if (this.lastDate > row.date) {
                    plan.appends.push(row.date); // 문자열 = 날짜구분선
                    this.lastDate = row.date;
                }
            }

            // 오더는 updated_at 을 기억해둔다. 폴링때 서버에 보내 변경분을 받아온다.
            if (row.rel_table == 'order') this.orderUptimes[row.rel_id] = row.data.updated_at;

            this.notis.push(row);
            plan.appends.push(row);
        });

        this.notis = this.notis.filter((v) => !v.removed);

        return plan;
    }

    /**
     * 폴링때 서버에 물어볼 오더 — 지금 화면에 보이는 것만. {ordernum: 마지막으로 그린 updated_at}
     */
    getVisibleOrders = () => {
        const orders = {};
        this.visibleOrders.forEach((ordernum) => {
            if (this.orderUptimes[ordernum] !== undefined) orders[ordernum] = this.orderUptimes[ordernum];
        });
        return orders;
    }

    /**
     * 서버가 돌려준 '바뀐 오더의 알림행' 으로 내부 목록과 화면을 갱신한다.
     */
    applyUpdates = (rows) => {
        rows.forEach((row) => {
            this.orderUptimes[row.rel_id] = row.data.updated_at;

            const idx = this.notis.findIndex((v) => v.pushnum == row.pushnum);
            if (idx < 0) return; // 아직 안 그린 알림 (스크롤로 내려오면 그때 최신값으로 그려진다)

            this.notis[idx] = row;
            this.refreshBox(row);
        });
    }

    /**
     * mergeRows 가 추려준 것을 화면에 반영한다.
     */
    render = (plan, mode) => {
        plan.removes.forEach((pushnum) => this.removeBox(pushnum));

        plan.appends.forEach((row) => {
            if (typeof row === 'string') this.appendDateLine(row);
            else if (!row.removed) this.appendBox(row, mode);
        });
    }

    /**
     * 알림 박스 html 을 만든다.
     * @param row 알림행
     * @param withWrap 바깥 래퍼(div#pushnum_N)까지 감쌀지 — 새로 추가할때만 true
     */
    buildBoxHtml = (row, withWrap) => {
        let tpl = row.rel_table == 'order' ? this.orderTemplate() : this.etcTemplate();
        if (withWrap) tpl = `<div class="m1_divA" id="pushnum_{pushnum}">${tpl}</div>`;

        return this.fillTemplate(tpl, this.prepareRow(row));
    }

    /**
     * 알림 박스를 추가한다.
     * @param row
     * @param mode MODE_OLDER(아래에 붙임), MODE_NEWER(위에 붙임)
     */
    appendBox = (row, mode) => {
        if (!row.title) return; // 제목없는 알림은 그리지 않는다 (현재 JB 엔 없다 — 있으면 페이징이 헛돈다)

        const $box = $(this.buildBoxHtml(row, true));

        if (mode == MODE_OLDER) $('#root').append($box);
        else $('#root').prepend($box);

        // 오더 카드는 가시성을 추적한다. 보이는 동안만 폴링 조회대상이 된다.
        if (row.rel_table == 'order') {
            $box[0].dataset.ordernum = row.rel_id;
            this.cardObserver.observe($box[0]);
        }
    }

    /**
     * 알림이 하나도 없을 때 — #root 를 빈 상태 문구로 채우고 더보기 영역(#bottomDivLine)을 감춘다.
     */
    showEmptyState = () => {
        $('#root').html('<div class="alim-empty">새로운 알림이 없습니다</div>');
        $('#bottomDivLine').hide();
    }

    /**
     * 날짜 구분선을 추가한다.
     */
    appendDateLine = (date) => {
        $('#root').append(`<div class="push_date1"><div class="push_date2"><div class="push_date3">${date}</div></div></div>`);
    }

    /**
     * 알림 박스의 내용만 새로 그린다. (바깥 래퍼는 유지 — 가시성 옵저버가 붙어있다)
     */
    refreshBox = (row) => {
        if (!row.title) return;

        $('#pushnum_' + row.pushnum).html(this.buildBoxHtml(row, false));
    }

    /**
     * 알림 박스를 지운다.
     */
    removeBox = (pushnum) => {
        const $box = $('#pushnum_' + pushnum);
        if (!$box.length) return;

        const ordernum = $box[0].dataset.ordernum;
        if (ordernum) {
            this.cardObserver.unobserve($box[0]);
            this.visibleOrders.delete(ordernum);
        }

        $box.remove();
    }

    /**
     * 템플릿에 넣을 값을 만든다. 특히 알림 종류별 버튼을 결정한다.
     * @returns {object} row 사본 + adm_txt / button
     */
    prepareRow = (row) => {
        const soojooUrl = `/m/soojoo?odnum=${row.rel_id}`;       // 수주 페이지
        const diaryUrl  = `/m/diary/list?showipicknum=${row.rel_id}`;// 일지 페이지

        let button = { url: '', txt: '', style: 'none' };

        switch (row.rel_table) {
            case 'order':
                switch (row.rel_action) {
                    case 'register': // 접수알림
                        button = { url: '', txt: '접수됨', style: 'gray' };
                        // 2024.12.11 취소된것 표시하지 않기
                        if (row.data.order_status >= 6) {
                            button = { fn: `$j.p.goMap(${row.rel_id})`, txt: '접수종료', style: 'gray' };
                        }
                        break;

                    case 'match': // 매칭알림
                        button = { url: soojooUrl, txt: row.data.order_status >= 6 ? '매칭종료' : '매칭됨', style: 'orange' };
                        break;

                    case 'direct': // 지정발주
                        if (row.target == '수주자' && row.data.order_status < '6') {
                            button = { url: soojooUrl, txt: '매칭됨', style: 'orange' };
                        } else {
                            button = { url: diaryUrl, txt: '바로가기', style: 'normal' };
                        }
                        break;

                    case 'app_direct':  // 어플발주후 지정대기 (3분전)
                    case 'app_direct2': // 어플발주후 지정대기 (2분전)
                    case 'reserve':     // 수주대기홀드
                    case 'forward':     // 오더전달
                        button = { url: soojooUrl, txt: '매칭됨', style: 'orange' };
                        break;

                    case 'cancel': // 발주취소
                        button = { url: '', txt: '취소됨', style: 'gray' };
                        break;

                    case 'document_rq': // 서류요청
                        button = { fn: `$j.p.goDocRequest(${row.rel_id})`, txt: '바로가기', style: 'normal' };
                        break;

                    case 'alarm':           // 알림
                    case 'recv':            // 수주
                    case 'select':          // 작업지정 (기사,차량 선택)
                    case 'select_cancel':   // 작업기사취소
                    case 'select_confirm':  // 지정확인
                    case 'direct_confirm':  // 지정확인
                    case 'cancel_rq':       // 작업취소요청
                    case 'modify_date':     // 날짜 변경
                    case 'modify_fee':      // 수수료없음으로 변경
                    case 'modify_howtopay': // 결제책임 변경
                    case 'modify_price':    // 가격변경
                    case 'low_price':       // 저단가 변경 (가격변경과 따로 온다)
                    case 'low_price_off':   // 저단가 해제 (가격변경과 따로 온다)
                    case 'arrive_rq':       // 현장도착요청
                    case 'arrive':          // 현장도착
                    case 'done_rq':         // 작업완료요청
                    case 'done':            // 작업완료
                    case 'sign':            // 외부서명
                    case 'whanwon':         // 환원예정알림
                    case 'whanwon_done':    // 환원알림
                    case 'pay_rq':          // 수금완료요청
                    case 'pay':             // 수금완료
                    case 'pay_all':         // 수금완료
                    case 'photo':           // 사진등록
                    case 'memo':            // 메모
                    case 'document':        // 서류
                    case 'mercury-photos':  // 머큐리-필수서류
                        button = { url: `/m/alim/redirect?ordernum=${row.rel_id}`, txt: '바로가기', style: 'normal' };
                        break;
                }
                break;

            case 'notice':
                // 관리자(대리로그인·CS)는 상세 대신 '실제 팝업 모습'을 지금 화면 위에 바로 띄운다. 일반 사용자는 종전대로 상세로.
                if (typeof G5 !== 'undefined' && G5.isAdmin) {
                    button = { fn: `$j.p.previewNotice(${row.rel_id})`, txt: '미리보기', style: 'normal' };
                } else {
                    button = { url: `/m/notice/${row.rel_id}`, txt: '바로가기', style: 'normal' };
                }
                break;

            case 'talk':
                button = { url: `/m/chat?mname=장비불러톡&rno=${row.rel_id}`, txt: '바로가기', style: 'normal' };
                break;

            case 'member':
                switch (row.rel_action) {
                    case 'join':
                        button = { fn: '$j.F.Member.ModalCarOption.changeDriverType()', txt: '유형변경', style: 'normal' };
                        break;
                    case 'doc_register':
                        button = { fn: "location.href='/m/docs/v1'", txt: '서류등록', style: 'normal' };
                        break;
                    case 'card_merchant_active': // 카드가맹 승인
                        button = { url: '/m/cardpay', txt: '바로가기', style: 'normal' };
                        break;
                }
                break;
        }

        // 버튼 onclick — fn 이 있으면 그대로, url 이면 페이지이동으로 감싼다.
        if (button.fn) button.url = button.fn;
        else if (button.url) button.url = `$j.p.goPage('${button.url}')`;

        button.txt = button.txt.split('').join('<br/>'); // 세로쓰기

        // 관리자 전용 메세지는 버튼을 감춘다.
        if (row.is_admin == 1) button = { url: '', txt: '', style: 'none' };

        // 제목·현장주소는 서버가 이스케이프하지 않고 내린다 (msg·adm_msg·body·opt 는 서버가 이미 이스케이프)
        const data = (row.data && typeof row.data === 'object')
            ? { ...row.data, addr: Util.escapeHtml(row.data.addr) } : row.data;
        return {
            ...row,
            title: Util.escapeHtml(row.title),
            data: data,
            adm_txt: row.is_admin == 0 ? '&nbsp;' : '관',
            button: button,
        };
    }

    /**
     * 템플릿의 {키} 를 값으로 채운다. {data.val} 같은 2-depth 도 처리한다.
     * 값이 null 이면 건너뛴다.
     */
    fillTemplate = (tpl, row) => {
        Object.keys(row).forEach((key) => {
            const val = row[key];
            if (val == null) return;

            if (typeof val === 'object') {
                Object.keys(val).forEach((sub) => {
                    tpl = tpl.replace(`{${key}.${sub}}`, val[sub]);
                });
            } else {
                tpl = tpl.replace(`{${key}}`, val);
            }
        });
        return tpl;
    }

    /**
     * 오더 알림 템플릿
     * 제목 색상({color})만 인라인 — rel_action 별로 서버가 정해준다. 나머지 스타일은 _alim.scss.
     */
    orderTemplate = () => `
   <table class="push-tbl">
      <colgroup>
         <col class="push-col-main">
         <col class="push-col-date">
         <col class="push-col-btn">
      </colgroup>
      <tbody>
         <tr>
            <td class="push-head is-order">
               <div class="managerD{is_admin}">{adm_txt}</div>
               <span class="push-title" style="color:{color}">{title}</span>
               <div class="cartype">{data.t}</div>
            </td>
            <td class="datesidea">{reg_date}</td>
            <td rowspan="3" class="push_box003">
                <button type="button" class="push_btn_{button.style}" onclick="{button.url}">{button.txt}</button>
            </td>
         </tr>
         <tr>
            <td class="push_box002"><span class="push-due">{data.w} </span><b>{data.m}/{data.d}</b> {data.yo} <b>{data.h}:{data.i}</b> {data.long}<br>{data.addr}<span class="push-msg">{msg}</span><span class="push-admsg">{adm_msg}</span></td>
            <td class="push_box001">{data.p}P<br>{data.r}<br><span class="push-option">{data.opt}</span></td>
         </tr>
      </tbody>
   </table>
    `;

    /**
     * 오더 이외 알림 템플릿
     */
    etcTemplate = () => `
   <table class="push-tbl">
      <colgroup>
         <col class="push-col-main">
         <col class="push-col-date">
         <col class="push-col-btn">
      </colgroup>
      <tbody>
         <tr>
            <td class="push-head">
               <div class="managerD{is_admin}">{adm_txt}</div>
               <span class="push-title" style="color:{color}"><b>{title}</b></span>
               <div class="cartype"></div>
            </td>
            <td class="datesidea">{reg_date}</td>
            <td rowspan="3" class="push_box003">
                <button type="button" class="push_btn_{button.style}" onclick="{button.url}">{button.txt}</button>
            </td>
         </tr>
         <tr>
            <td colspan="2" class="push-etc-body">{data.body}</td>
         </tr>
      </tbody>
   </table>
    `;

    /**
     * 페이지 이동 — 로딩 이미지를 띄운 뒤 이동한다.
     */
    goPage(url) {
        document.getElementById('PageMoveLoading').style.display = 'block';

        // 로딩 표시가 실제로 그려진 뒤에 이동한다.
        // (예전엔 GIF 를 preload 해 onload 를 기다렸지만, 지금은 CSS 인디케이터라 받아올 게 없다.
        //  대신 rAF 두 번 = "다음 프레임이 화면에 나간 뒤" 를 기다린다.)
        requestAnimationFrame(() => requestAnimationFrame(() => { document.location.href = url; }));
    }

    /**
     * 접수종료 리뷰 지도(수주자와 내 위치 비교) 표시.
     * 닫기는 지도 페이지 안의 X 가 $j.Ui.FullFrame.parent().close() 로 호출한다.
     */
    goMap(ordernum) {
        // 지도·이미지편집기와 같은 전체화면 iframe 레이어. id 는 기존 것을 유지한다
        // (리뷰 지도 페이지가 parent 에서 이 id 로 자기를 닫는다).
        $j.Ui.FullFrame.open(`/m/map/review-order-match?ordernum=${ordernum}`, {
            id: 'maporderstatusshow',
            title: '접수종료 리뷰 지도',
        });
    }

    /**
     * 공지 알림 → 실제 전체팝업 모습을 지금 보고 있는 화면 위에 바로 띄운다 (관리자 전용).
     * 이미 /m/alim(실제 앱 화면)에 있으므로 새 창을 열지 않고 그 자리에서 preview() 로 렌더한다.
     * 대리로그인 중 자동팝업은 억제되지만 preview() 는 그 억제를 거치지 않는다.
     */
    previewNotice(id) {
        $.get('/m/ajax/popup/preview-item', { num: id }, (res) => {
            if (res && res.result && res.item) $j.F.Popup.preview(res.item);
            else alert('미리보기할 공지 팝업이 아닙니다.');
        });
    }

    /**
     * 서류 요청 보기
     */
    goDocRequest(ordernum) {
        $.ajax({
            type: 'GET', url: '/m/ajax/doc-share/request-info', data: { ordernum: ordernum },
            success: (data) => {
                if (data.result != true) {
                    alert(data.error);
                    return;
                }
                document.location.href = data.linkaddr;
            }
        });
    }
}
